import { Injectable } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Ability } from '../interfaces/ability/ability.model';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  private headerListSystemUser: MenuItem[] = [
    {
      label: 'Početna',
      route: '/home',
      icon: 'pi pi-home',
    },
    {
      label: 'Članci',
      icon: 'pi pi-list',
      items: [
        {
          label: 'Svi članci',
          route: '/post-list',
        },
        {
          label: 'Dodaj novi članak',
          route: ['/post-add-edit'],
        },
      ],
    },
    {
      label: 'Kategorije',
      icon: 'pi pi-paperclip',
      items: [
        {
          label: 'Sve kategorije',
          route: '/category-list',
        },
        {
          label: 'Dodaj kategoriju',
          route: '/category-add-edit',
        },
      ],
    },
    {
      label: 'Naslovna strana',
      icon: 'pi pi-table',
      route: '/home-page-structure',
    },
    {
      label: 'Udarne vijesti',
      icon: 'pi pi-thumbtack',
      route: '/breaking-news',
    },
    {
      label: 'Izvori',
      icon: 'pi pi-database',
      items: [
        {
          label: 'Svi izvori',
          route: '/source-list',
        },
        {
          label: 'Dodaj izvor',
          route: '/source-add-edit',
        },
      ],
    },
    {
      label: 'Slike',
      icon: 'pi pi-images',
      items: [
        {
          label: 'Sve slike',
          route: '/image-list',
        },
        {
          label: 'Dodaj sliku',
          route: '/image-add-edit',
        },
      ],
    },
    {
      label: 'Galerije',
      icon: 'pi pi-images',
      items: [
        {
          label: 'Sve galerije',
          route: '/gallery-list',
        },
        {
          label: 'Kreiraj galeriju',
          route: '/gallery-add-edit/:id',
        },
      ],
    },
    {
      label: 'Dokumenti',
      icon: 'pi pi-folder',
      items: [
        {
          label: 'Svi dokumenti',
          route: '/document-list',
        },
        {
          label: 'Kreiraj dokument',
          route: '/document-add-edit',
        },
      ],
    },
    {
      label: 'Stranice',
      icon: 'pi pi-file',
      items: [
        {
          label: 'Sve stranice',
          route: '/static-page-list',
        },
        {
          label: 'Dodaj stranicu',
          route: '/static-page-add-edit',
        },
      ],
    },
    {
      label: 'Tagovi',
      icon: 'pi pi-tags',
      items: [
        {
          label: 'Svi tagovi',
          route: '/tag-list',
        },
        {
          label: 'Dodaj tag',
          route: '/tag-add-edit',
        },
      ],
    },
    {
      label: 'Menu',
      icon: 'pi pi-bars',
      items: [
        {
          label: 'Glavni meni',
          route: '/menu-main',
        },
        {
          label: 'Footer meni',
          route: '/menu-footer',
        },
      ],
    },
    {
      label: 'Ankete',
      icon: 'pi pi-chart-bar',
      items: [
        {
          label: 'Sve ankete',
          route: '/poll-list',
        },
        {
          label: 'Dodaj anketu',
          route: '/poll-add-edit',
        },
      ],
    },
    {
      label: 'Komentari',
      icon: 'pi pi-comment',
      route: '/comments',
    },
    {
      label: 'Baneri',
      icon: 'pi pi-ticket',
      items: [
        {
          label: 'Svi baneri',
          route: '/banner-list',
        },
        {
          label: 'Kategorija baneri',
          route: '/banner-add-category-page',
        },
        {
          label: 'Članak baneri',
          route: '/banner-add-single-page',
        },
      ],
    },
    {
      label: 'Korisnici',
      icon: 'pi pi-users',
      items: [
        {
          label: 'Svi korisnici',
          route: '/user-list',
        },
        {
          label: 'Dodaj korisnika',
          route: '/user-add-edit',
        },
      ],
    },
    {
      label: 'Uloge',
      icon: 'pi pi-user',
      items: [
        {
          label: 'Sve uloge',
          route: '/role-list',
        },
        {
          label: 'Dodaj ulogu',
          route: '/role-add-edit',
        },
      ],
    },
  ];
  constructor(private authService: AuthService) {}

  getMenuList(): Observable<MenuItem[]> {
    return this.authService.activeUser$.pipe(
      map((user) => {
        if (user?.data.roles[0].is_system_role) {
          return this.headerListSystemUser;
        } else {
          return this.formMenuList(user?.data.roles[0].abilities);
        }
      })
    );
  }

  formMenuList(abilities: Ability[] | undefined): MenuItem[] {
    const menuList: MenuItem[] = [];
    // console.log(abilities);

    // Add dashboard menu item
    if (abilities?.some((a) => a.name === 'view_dashboard')) {
      menuList.push({
        label: 'Početna',
        route: '/home',
        icon: 'pi pi-home',
      });
    }

    // Add articles menu item
    if (abilities?.some((a) => a.name === 'view_any_article')) {
      if (abilities?.some((a) => a.name === 'create_article')) {
        menuList.push({
          label: 'Članci',
          icon: 'pi pi-list',
          items: [
            {
              label: 'Svi članci',
              route: '/post-list',
            },
            {
              label: 'Dodaj novi članak',
              route: '/post-add-edit',
            },
          ],
        });
      } else {
        menuList.push({
          label: 'Članci',
          icon: 'pi pi-list',
          items: [
            {
              label: 'Svi članci',
              route: '/post-list',
            },
          ],
        });
      }
    }

    // Add categories menu item
    if (abilities?.some((a) => a.name === 'view_any_category')) {
      if (abilities?.some((a) => a.name === 'create_category')) {
        menuList.push({
          label: 'Kategorije',
          icon: 'pi pi-paperclip',
          items: [
            {
              label: 'Sve kategorije',
              route: '/category-list',
            },
            {
              label: 'Dodaj kategoriju',
              route: '/category-add-edit',
            },
          ],
        });
      } else {
        menuList.push({
          label: 'Kategorije',
          icon: 'pi pi-paperclip',
          items: [
            {
              label: 'Sve kategorije',
              route: '/category-list',
            },
          ],
        });
      }
    }

    // Add article collections menu item
    if (abilities?.some((a) => a.name === 'view_any_template_collection')) {
      if (abilities?.some((a) => a.name === 'create_template_collection')) {
        menuList.push({
          label: 'Naslovna strana',
          icon: 'pi pi-table',
          route: '/home-page-structure',
        });
      }
    }

    // Add notifications menu item
    if (abilities?.some((a) => a.name === 'view_any_website_notification')) {
      if (abilities?.some((a) => a.name === 'create_website_notification')) {
        menuList.push({
          label: 'Udarne vijesti',
          icon: 'pi pi-thumbtack',
          route: '/breaking-news',
        });
      }
    }

    // Add sources menu item
    if (abilities?.some((a) => a.name === 'view_any_source')) {
      if (abilities?.some((a) => a.name === 'create_source')) {
        menuList.push({
          label: 'Izvori',
          icon: 'pi pi-database',
          items: [
            {
              label: 'Svi izvori',
              route: '/source-list',
            },
            {
              label: 'Dodaj izvor',
              route: '/source-add-edit',
            },
          ],
        });
      } else {
        menuList.push({
          label: 'Izvori',
          icon: 'pi pi-database',
          items: [
            {
              label: 'Svi izvori',
              route: '/source-list',
            },
          ],
        });
      }
    }

    // Add images menu item

    if (abilities?.some((a) => a.name === 'view_any_image')) {
      if (abilities?.some((a) => a.name === 'create_image')) {
        menuList.push({
          label: 'Slike',
          icon: 'pi pi-images',
          items: [
            {
              label: 'Sve slike',
              route: '/image-list',
            },
            {
              label: 'Dodaj sliku',
              route: '/image-add-edit',
            },
          ],
        });
      } else {
        menuList.push({
          label: 'Slike',
          icon: 'pi pi-database',
          items: [
            {
              label: 'Sve slike',
              route: '/image-list',
            },
          ],
        });
      }
    }

    // Add Galery menu item
    if (abilities?.some((a) => a.name === 'view_any_gallery')) {
      if (abilities?.some((a) => a.name === 'create_gallery')) {
        menuList.push({
          label: 'Galerije',
          icon: 'pi pi-images',
          items: [
            {
              label: 'Sve galerije',
              route: '/gallery-list',
            },
            {
              label: 'Kreiraj galeriju',
              route: '/gallery-add-edit',
            },
          ],
        });
      } else {
        menuList.push({
          label: 'Galerije',
          icon: 'pi pi-images',
          items: [
            {
              label: 'Sve galerije',
              route: '/gallery-list',
            },
          ],
        });
      }
    }

    // Add documents menu item
    if (abilities?.some((a) => a.name === 'view_any_file')) {
      if (abilities?.some((a) => a.name === 'create_file')) {
        menuList.push({
          label: 'Dokumenti',
          icon: 'pi pi-folder',
          items: [
            {
              label: 'Svi dokumenti',
              route: '/document-list',
            },
            {
              label: 'Kreiraj dokument',
              route: '/document-add-edit',
            },
          ],
        });
      } else {
        menuList.push({
          label: 'Dokumenti',
          icon: 'pi pi-folder',
          items: [
            {
              label: 'Svi dokumenti',
              route: '/document-list',
            },
          ],
        });
      }
    }

    // Add pages menu item
    if (abilities?.some((a) => a.name === 'view_any_page')) {
      if (abilities?.some((a) => a.name === 'create_page')) {
        menuList.push({
          label: 'Stranice',
          icon: 'pi pi-file',
          items: [
            {
              label: 'Sve stranice',
              route: '/static-page-list',
            },
            {
              label: 'Dodaj stranicu',
              route: '/static-page-add-edit',
            },
          ],
        });
      } else {
        menuList.push({
          label: 'Stranice',
          icon: 'pi pi-file',
          items: [
            {
              label: 'Sve stranice',
              route: '/static-page-list',
            },
          ],
        });
      }
    }

    // Add tags menu item
    if (abilities?.some((a) => a.name === 'view_any_tag')) {
      if (abilities?.some((a) => a.name === 'create_tag')) {
        menuList.push({
          label: 'Tagovi',
          icon: 'pi pi-tags',
          items: [
            {
              label: 'Svi tagovi',
              route: '/tag-list',
            },
            {
              label: 'Dodaj tag',
              route: '/tag-add-edit',
            },
          ],
        });
      } else {
        menuList.push({
          label: 'Tagovi',
          icon: 'pi pi-tags',
          items: [
            {
              label: 'Svi tagovi',
              route: '/tag-list',
            },
          ],
        });
      }
    }

    // Add Menus menu item
    if (abilities?.some((a) => a.name === 'view_any_menu')) {
      if (abilities?.some((a) => a.name === 'create_menu')) {
        menuList.push({
          label: 'Menu',
          icon: 'pi pi-bars',
          items: [
            {
              label: 'Glavni meni',
              route: '/menu-main',
            },
            {
              label: 'Footer meni',
              route: '/menu-footer',
            },
          ],
        });
      }
    }

    // Add Polls menu item
    if (abilities?.some((a) => a.name === 'view_any_poll')) {
      if (abilities?.some((a) => a.name === 'update_poll')) {
        menuList.push({
          label: 'Ankete',
          icon: 'pi pi-chart-bar',
          items: [
            {
              label: 'Sve ankete',
              route: '/poll-list',
            },
            {
              label: 'Dodaj anketu',
              route: '/poll-add-edit',
            },
          ],
        });
      } else {
        menuList.push({
          label: 'Ankete',
          icon: 'pi pi-chart-bar',
          items: [
            {
              label: 'Sve ankete',
              route: '/poll-list',
            },
          ],
        });
      }
    }

    // Add comments menu item
    if (abilities?.some((a) => a.name === 'view_any_article_comment')) {
      if (abilities?.some((a) => a.name === 'update_article_comment')) {
        menuList.push({
          label: 'Komentari',
          icon: 'pi pi-comment',
          route: '/comments',
        });
      }
    }

    // Add banners menu item
    if (abilities?.some((a) => a.name === 'view_any_banner')) {
      if (abilities?.some((a) => a.name === 'create_banner')) {
        menuList.push({
          label: 'Baneri',
          icon: 'pi pi-ticket',
          items: [
            {
              label: 'Svi baneri',
              route: '/banner-list',
            },
            {
              label: 'Kategorija baneri',
              route: '/banner-add-category-page',
            },
            {
              label: 'Članak baneri',
              route: '/banner-add-single-page',
            },
          ],
        });
      } else {
        menuList.push({
          label: 'Baneri',
          icon: 'pi pi-ticket',
          items: [
            {
              label: 'Svi baneri',
              route: '/banner-list',
            },
          ],
        });
      }
    }

    // Add users menu item
    if (abilities?.some((a) => a.name === 'view_any_user')) {
      if (abilities?.some((a) => a.name === 'create_user')) {
        menuList.push({
          label: 'Korisnici',
          icon: 'pi pi-users',
          items: [
            {
              label: 'Svi korisnici',
              route: '/user-list',
            },
            {
              label: 'Dodaj korisnika',
              route: '/user-add-edit',
            },
          ],
        });
      } else {
        menuList.push({
          label: 'Korisnici',
          icon: 'pi pi-users',
          items: [
            {
              label: 'Svi korisnici',
              route: '/user-list',
            },
          ],
        });
      }
    }

    // Add roles menu item
    if (abilities?.some((a) => a.name === 'view_any_role')) {
      if (abilities?.some((a) => a.name === 'create_role')) {
        menuList.push({
          label: 'Uloge',
          icon: 'pi pi-user',
          items: [
            {
              label: 'Sve uloge',
              route: '/role-list',
            },
            {
              label: 'Dodaj ulogu',
              route: '/role-add-edit',
            },
          ],
        });
      } else {
        menuList.push({
          label: 'Uloge',
          icon: 'pi pi-user',
          items: [
            {
              label: 'Sve uloge',
              route: '/role-list',
            },
          ],
        });
      }
    }
    return menuList;
  }
}
